import { type ReactNode } from 'react';
import { IntercomProvider as UseIntercomProvider } from 'react-use-intercom';

import { useOptionalUser } from '@/features/auth/hooks';

export const IntercomProvider = ({ children }: { children: ReactNode }) => {
  const user = useOptionalUser();

  return (
    <UseIntercomProvider
      appId={import.meta.env.VITE_INTERCOM_APP_ID}
      autoBoot
      autoBootProps={{
        hideDefaultLauncher: false,
        // The signed token from api-internal carries the whole identity — user id,
        // email, name, plan and monitor counts all sit inside the signature. Nothing
        // else may be passed here: Intercom requires a verified update for each of
        // those attributes, so a browser-supplied copy is discarded and would only
        // invite the two payloads to drift. No token means an anonymous visitor,
        // which is also what an unauthenticated checkout gets.
        intercomUserJwt: user?.intercomUserJwt,
      }}
    >
      {children}
    </UseIntercomProvider>
  );
};
